import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DocumentDetailsModel } from '../../Interfaces'

const emptyDocumentDetails: DocumentDetailsModel = {
  docGuid: '',
  docName: '',
  docType: '',
  subType: '',
  docTypeDescn: '',
  subTypeDescn: '',
  docDate: '',
  createdBy: '',
  createdByName: '',
  created: '',
  lastUpdBy: '',
  lastUpdTime: '',
  deleted: '',
  fileArchived: '',
  pdfExists: '',
  documentOwner: '',
  documentOwnerName: '',
  originalFileName: '',
  originalFilePath: '',
  lockedBy: '',
  lockedDate: '',
  version: '',
  attachmentInd: '',
  keyCombination: '',
  folder: '',
  descn: '',
  sentBy: '',
  sentTo: '',
  attachment: '',
  docLockedBy: '',
  docLockedDate: ''
}

interface DocumentDetailsState {
  documentDetails: DocumentDetailsModel[]
}

const initialState: DocumentDetailsState = {
  documentDetails: []
}

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setSearchResults: (state, action: PayloadAction<DocumentDetailsModel[]>) => {
      state.documentDetails = action.payload
    },
    clearSearchResults: (state) => {
      state.documentDetails = []
    }
  }
})

export const { setSearchResults, clearSearchResults } = searchSlice.actions
export const searchResultReducer = searchSlice.reducer
